const CITY_THUMB = {
    "阿姆斯特丹": '//doc.yctop.com/fla/city/thumb/阿姆斯特丹.jpg',
    "巴黎": '//doc.yctop.com/fla/city/thumb/巴黎.jpg',
    "大阪": '//doc.yctop.com/fla/city/thumb/大阪.jpg',
    "德里": '//doc.yctop.com/fla/city/thumb/德里.jpg',
    "迪拜": '//doc.yctop.com/fla/city/thumb/迪拜.jpg',
    "东京": '//doc.yctop.com/fla/city/thumb/东京.jpg',
    "多伦多": '//doc.yctop.com/fla/city/thumb/多伦多.jpg',
    "法兰克福": '//doc.yctop.com/fla/city/thumb/法兰克福.jpg',
    "吉隆坡": '//doc.yctop.com/fla/city/thumb/吉隆坡.jpg',
    "旧金山": '//doc.yctop.com/fla/city/thumb/旧金山.jpg',
    "伦敦": '//doc.yctop.com/fla/city/thumb/伦敦.jpg',
    "洛杉矶": '//doc.yctop.com/fla/city/thumb/洛杉矶.jpg',
    "曼谷": '//doc.yctop.com/fla/city/thumb/曼谷.jpg',
    "曼彻斯特": '//doc.yctop.com/fla/city/thumb/曼彻斯特.jpg',
    "孟买": '//doc.yctop.com/fla/city/thumb/孟买.jpg',
    "米兰": '//doc.yctop.com/fla/city/thumb/米兰.jpg',
    "莫斯科": '//doc.yctop.com/fla/city/thumb/莫斯科.jpg',
    "纽约": '//doc.yctop.com/fla/city/thumb/纽约.jpg',
    "仁川": '//doc.yctop.com/fla/city/thumb/仁川.jpg',
    "首尔": '//doc.yctop.com/fla/city/thumb/首尔.jpg',
    "台北": '//doc.yctop.com/fla/city/thumb/台北.jpg',
    "香港": '//doc.yctop.com/fla/city/thumb/香港.jpg',
    "新加坡": '//doc.yctop.com/fla/city/thumb/新加坡.jpg',
    "休斯敦": '//doc.yctop.com/fla/city/thumb/休斯敦.jpg',
    "伊斯坦布尔": '//doc.yctop.com/fla/city/thumb/伊斯坦布尔.jpg',
    "芝加哥": '//doc.yctop.com/fla/city/thumb/芝加哥.jpg',
    "悉尼": '//doc.yctop.com/fla/city/thumb/悉尼.jpg',
}

const ROUTE_THUMB = {
    "北美": '//doc.yctop.com/fla/route/thumb/北美.jpg',
    "东南亚": '//doc.yctop.com/fla/route/thumb/东南亚.jpg',
    "非洲": '//doc.yctop.com/fla/route/thumb/非洲.jpg',
    "南美": '//doc.yctop.com/fla/route/thumb/南美.jpg',
    "南亚": '//doc.yctop.com/fla/route/thumb/南亚.jpg',
    "欧洲": '//doc.yctop.com/fla/route/thumb/欧洲.jpg',
    "日韩": '//doc.yctop.com/fla/route/thumb/日韩.jpg',
    "中东": '//doc.yctop.com/fla/route/thumb/中东.jpg',
    "中亚": '//doc.yctop.com/fla/route/thumb/中亚.jpg',
}

const getThumb = function(route, city, end) {
	let thumb = CITY_THUMB[city] || ROUTE_THUMB[route] || '//doc.yctop.com/fla/route/thumb/default.jpg'
	if(end) {
		thumb = thumb.replace(".jpg", "-h.jpg")
	}
	return thumb + '?imageView2/0/q/60'
}



export {
	getThumb as GetThumb
}